<div
    class="select-container me-2 truncate"
    (click)="isUpdatingCategory || checkCategoryChangeStatus()"
    tooltip="{{ category ? ('Category' | translate) + ': ' + (category | categoryFullName) : '' }}"
    container="body"
    placement="auto">
    <span class="category-selector" [ngClass]="{ 'text-light': !category || isUpdatingCategory }">
        {{ category ? category.label : ('Choose category' | translate) }}</span
    >
</div>
